<div i18n="@@getInTouch" class="mat-headline-4">Get in touch!</div>
<mat-card class="contact-card">
  <mat-card-content class="contact-card-content">
    <img src="{{utils.isDarkMode() ? '../../../assets/images/contact-us-dark.svg' : '../../../assets/images/contact-us.svg'}}" alt="Contact us illustration" i18n-alt="@@contactImageAlt">
    <div class="w-100">
      <form class="contact-form" [formGroup]="contactUsForm">
        <div class="form-group">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label i18n="@@fullNameLabel">Full name</mat-label>
            <input data-testid="contact_us_name" matInput id="name" placeholder="Full name" i18n-placeholder="@@fullNamePlaceholder" name="name" formControlName="name" required />
            <mat-error>
              @if (!contactUsForm.get('name').valid && contactUsForm.get('name').touched) {
                @if (contactUsForm.get('name').errors && contactUsForm.get('name').errors['required'] || contactUsForm.get('name').hasError('whitespace')) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label i18n="@@emailLabel">Email</mat-label>
            <input data-testid="contact_us_email" matInput id="email" placeholder="Email" i18n-placeholder="@@emailPlaceholder" name="email" formControlName="email" required />
            <mat-error>
              @if (!contactUsForm.get('email').valid && contactUsForm.get('email').touched) {
                @if (contactUsForm.get('email').errors && contactUsForm.get('email').errors['required']) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
              @if (contactUsForm.get('email').errors && !contactUsForm.get('email').errors['required'] && contactUsForm.get('email').errors['emailNotValid']) {
                <span i18n="@@inValidEmail">Please enter a valid email</span>
              }
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label i18n="@@messageLabel">Message</mat-label>
            <textarea data-testid="contact_us_message" matInput id="message" placeholder="Message" i18n-placeholder="@@messagePlaceholder" name="message" formControlName="message" required></textarea>
            <mat-error>
              @if (!contactUsForm.get('message').valid && contactUsForm.get('message').touched) {
                @if (contactUsForm.get('message').errors && contactUsForm.get('message').errors['required'] || contactUsForm.get('message').hasError('whitespace')) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
            </mat-error>
          </mat-form-field>
        </div>
        <div class="accept-terms-style mat-caption">
          <mat-checkbox data-testid="terms_privacy" (change)="privacyAndTerms($event)" color="accent"><span i18n="@@iAccept">I accept the </span><a i18n="@@privacyStatement" routerLink="/privacy">Privacy Statement.</a></mat-checkbox>
          @if (checkedPrivacyAndTerms === false) {
            <p i18n="@@acceptPrivacyStatement" class="error mt-10" >Please accept privacy statement</p>
          }
        </div>
        <ngx-invisible-recaptcha #captchaElem
          siteKey="6LfeOtQZAAAAAPOcnGBEQds3znzef6VbrC1RGW9u"
          (reset)="handleReset()"
          (ready)="handleReady()"
          (load)="handleLoad()"
          (success)="handleSuccess($event)"
          [ngModel]="recaptcha"
          [ngModelOptions]="{ standalone: true }">
        </ngx-invisible-recaptcha>
        <div>
          <button i18n="@@submit" data-testid="contact_us_button" class="w-100"  mat-raised-button color="primary" (click)="onSubmit()">Submit</button>
        </div>
      </form>
    </div>
  </mat-card-content>
</mat-card>
